import { css, CSSResult } from 'lit'


export const cseIcon = {
  verticalAlign: css`var(--cse-icon-vertical-align, text-top)`,
  size: css`var(--cse-icon-size, initial)`,
  color: css`var(--cse-icon-color, inherit)`,
  width: css`var(--cse-icon-width, 1.25em)`,
}

export const cseIconSizes = {
  sizeXxs: css`var(--cse-icon-size, var(--cse-icon-size-xxs, 0.625em))`,
  sizeXs: css`var(--cse-icon-size, var(--cse-icon-size-xs, 0.75em))`,
  sizeSm: css`var(--cse-icon-size, var(--cse-icon-size-sm, 0.875em))`,
  sizeMd: css`var(--cse-icon-size, var(--cse-icon-size-md, 1em))`,
  sizeLg: css`var(--cse-icon-size, var(--cse-icon-size-lg, 1.25em))`,
  sizeXl: css`var(--cse-icon-size, var(--cse-icon-size-xl, 1.625em))`,
}

export const style: CSSResult = css`
  :host {
    display: inline-flex;
    justify-content: center;
    width: ${cseIcon.width};
    color: ${cseIcon.color};
    vertical-align: ${cseIcon.verticalAlign};
  }
  
  :host([icon-hidden]) {
    display: contents;
  }

  :host([size="xxs"]) {
    font-size: ${cseIconSizes.sizeXxs};
  }

  :host([size="xs"]) {
    font-size: ${cseIconSizes.sizeXs};
  }

  :host([size="sm"]) {
    font-size: ${cseIconSizes.sizeSm};
  }

  :host([size="md"]) {
    font-size: ${cseIconSizes.sizeMd};
  }

  :host([size="lg"]) {
    font-size: ${cseIconSizes.sizeLg};
  }

  :host([size="xl"]) {
    font-size: ${cseIconSizes.sizeXl};
  }
`
